var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBracelet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#221F1F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.29,264.2h-61.6c-3.2,0-5.79,2.59-5.79,5.79v48.85c0,3.2,2.59,5.79,5.79,5.79h61.6 c3.2,0,5.79-2.59,5.79-5.79v-48.85C287.08,266.79,284.49,264.2,281.29,264.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.47,145.63c-99.34,0-199.98,23.66-199.98,68.85v43.86c0,34.09,57.23,55.9,127.96,64.58v4.69 c0,14.6,11.88,26.45,26.45,26.45h91.19c14.57,0,26.45-11.85,26.45-26.45v-4.69c70.73-8.68,127.96-30.49,127.96-64.58v-43.86 C450.49,169.29,349.85,145.63,250.47,145.63z M296.79,318.84c0,8.55-6.96,15.51-15.51,15.51h-61.6c-8.55,0-15.51-6.96-15.51-15.51 v-48.85c0-8.55,6.96-15.51,15.51-15.51h61.6c8.55,0,15.51,6.96,15.51,15.51V318.84z M322.53,263.42v-2.2 c0-14.6-11.88-26.45-26.45-26.45h-91.19c-14.57,0-26.45,11.85-26.45,26.45v2.2c-44.28-5.57-77.53-15.89-96.98-27.03 c28.91-16.48,88.14-31.33,169.01-31.33c80.86,0,140.13,14.86,169.04,31.33C400.05,247.53,366.81,257.85,322.53,263.42z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracelet);
export default __webpack_public_path__ + "static/media/bracelet.7b5621013e8cb6b540091c94364bea98.svg";
export { ForwardRef as ReactComponent };